import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import Checkbox from 'app/components/common/checkbox';
import Icon     from 'app/components/common/icon';
import EllipsisMenu from 'app/components/common/ellipsis-menu';

class BuilderSectionGroup extends React.PureComponent {

  constructor(props) {
    super(props);

    this.onChangeIsOn = this.onChangeIsOn.bind(this);
  }

  onChangeIsOn(event) {
    const isOn = event.target.checked;
    this.props.onToggle && this.props.onToggle(isOn);
  }

  render() {
    const {title, icon, color, isOn, children, hideToggle} = this.props;
    return (
      <div className={`cadmin-builder-sgroup ${color} is-on-${isOn}`}>
        <div className="cadmin-builder-sgroup-header">
          {icon}
          <h2>{title}</h2>
          <div className="cadmin-builder-sgroup-header-hr" />
          {!hideToggle && (
            <Checkbox checked={isOn} onChange={this.onChangeIsOn} isToggle />
          )}
        </div>
        {isOn && children}
      </div>
    );
  }

}

BuilderSectionGroup.propTypes = {
  children: PropTypes.any,
  title: PropTypes.string.isRequired,
  color: PropTypes.oneOf(['orange', 'green', 'purple', 'gray']),
  isOn: PropTypes.bool.isRequired,
  onToggle: PropTypes.func,
  hideToggle: PropTypes.bool,
  icon: PropTypes.node,
};

BuilderSectionGroup.defaultProps = {
  color: 'gray',
  title: 'Section Group',
  hideToggle: false,
};



class BuilderSectionGroupV2 extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      expanded: props.defaultExpanded,
    };

    this.onClickDelete = this.onClickDelete.bind(this);
    this.onClickMoveUp = this.onClickMoveUp.bind(this);
    this.onClickMoveDown = this.onClickMoveDown.bind(this);
    this.onClickToggleExpand = this.onClickToggleExpand.bind(this);
  }

  onClickDelete(event) {
    event.preventDefault();
    this.props.onDelete(this.props.index);
  }
  onClickMoveUp(event) {
    event.preventDefault();
    this.props.onMoveUp(this.props.index);
  }
  onClickMoveDown(event) {
    event.preventDefault();
    this.props.onMoveDown(this.props.index);
  }

  onClickToggleExpand() {
    this.props.onClick && this.props.onClick();
    if (!this.props.collapsible) return;
    this.setState((prevState) => {
      return {expanded: !prevState.expanded};
    });
  }

  render() {
    const {title, subtitle, children, onDelete, onMoveDown, onMoveUp, collapsible} = this.props;
    const hasMenu = !!(onDelete || onMoveDown || onMoveUp);
    const expanded = _.isBoolean(this.props.expanded)
      ? this.props.expanded
      : this.state.expanded || !collapsible;
    return (
      <div className={`ca-bldr-sgv2`}>
        <div className="ca-bldr-sgv2-head">
          <div className="ca-bldr-sgv2-head-caret" onClick={this.onClickToggleExpand}>
            {!!(collapsible || _.isBoolean(this.props.expanded)) && (
              <Icon.Caret direction={expanded ? 'up' : 'down'} />
            )}
          </div>
          <div className="ca-bldr-sgv2-head-texts" onClick={this.onClickToggleExpand}>
            <div className="ca-bldr-sgv2-head-texts-title">{title}</div>
            {!!subtitle && (
              <div className="ca-bldr-sgv2-head-texts-subtitle">{subtitle}</div>
            )}
          </div>
          {hasMenu && (
            <div className="ca-bldr-sgv2-head-menu">
              <EllipsisMenu usePortal>
                {!!onMoveUp && (<a href="#" onClick={this.onClickMoveUp}>Move Up</a>)}
                {!!onMoveDown && (<a href="#" onClick={this.onClickMoveDown}>Move Down</a>)}
                {!!onDelete && (<a href="#" onClick={this.onClickDelete}>Remove</a>)}
              </EllipsisMenu>
            </div>
          )}
        </div>
        {expanded && children}
      </div>
    );
  }

}

BuilderSectionGroupV2.propTypes = {
  children: PropTypes.any,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  index: PropTypes.number,
  onDelete: PropTypes.func,
  onMoveUp: PropTypes.func,
  onMoveDown: PropTypes.func,
  onClick: PropTypes.func,
  collapsible: PropTypes.bool,
  defaultExpanded: PropTypes.bool,
  expanded: PropTypes.bool,
};

BuilderSectionGroupV2.defaultProps = {
  collapsible: true,
  defaultExpanded: true,
  expanded: null,
};

BuilderSectionGroup.V2 = BuilderSectionGroupV2;

export default BuilderSectionGroup;
